<template>
  <Page :title="title">
    <div class="header">
      <div class="logo">
        <img :src="require('@/assets/img/logo.png')" alt="" />
      </div>
    </div>
    <div class="content">
      <surveyProblem
        :problem="currentProblem"
        :seq="seq"
        @change="changeOptions"
      ></surveyProblem>
      <div class="van-overlay loading" v-if="loading">
        <van-loading />
      </div>
    </div>
    <div class="footer flex">
      <div
        class="secondary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst !== '0'"
        @click="previous"
      >
        上一题
      </div>
      <div
        class="primary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst !== '1'"
        @click="next"
      >
        下一题
      </div>
      <div
        class="primary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst === '1'"
        @click="submit"
      >
        提交
      </div>
      <div
        v-if="!currentProblem.id"
        class="primary item1"
        @click="redirectClientDetail"
      >
        退出
      </div>
    </div>
  </Page>
</template>
<script lang="js">
import surveyProblem from './surveyProblem.vue';
export default {

    components:{
        surveyProblem: surveyProblem,
    },
    data(){
        return {
            title: '问卷调查',
            surveyId: null,
            custId: null,
            purchaseRecordId: null,
            survey: {},
            problems:[],
            current: 0,
            answers:[],
            currentProblem: {},
            loading: false,
        }
    },
    created(){
        let surveyId = this.$route.query.surveyId;
        let custId = this.$route.query.custId;
        let purchaseRecordId = this.$route.query.purchaseRecordId;
        this.surveyId = surveyId;
        this.custId = custId;
        this.purchaseRecordId = purchaseRecordId;
        if (surveyId && custId) {
            this.querySurveyDetail(surveyId, custId, purchaseRecordId);
        }
    },
    computed:{
        seq:{
            get(){
                return (this.current + 1) + '/' + this.problems.length + '.'
            }
        }
    },
    watch:{
        current(newVal, oldVal){
            this.currentProblem = {...this.problems[this.current]}
        }
    },
    mounted(){
    
    },
    methods: {
        async querySurveyDetail(surveyId, custId, purchaseRecordId){
            try {
                let response = await this.$api.querySurveyDetail({
                  salesId: this.$wxuserUtil.getUserId(),
                  surveyId: surveyId,
                  custId: custId,
                  purchaseRecordId: purchaseRecordId,
                })
                if(response.fail){
                    this.$title("查询问卷信息失败")
                    return
                }
                this.survey = response.data;
                this.problems = response.data.problems;
                this.problems.forEach(p => {
                    p.answer = {};
                })
                this.currentProblem = this.problems[0];
            } catch (error) {
                this.$title("查询问卷信息失败")
            }
        },
        changeOptions(problem){
            this.problems[this.current].answer = problem.answer
            this.problems[this.current].options = problem.options
        },
        previous(){
            if (!this.currentProblem.id) {
                return
            }
            // 第一题
            if(this.currentProblem.isOrFirst === 0){
                return              
            }
            let index = this.problems.findIndex( p => p.next === this.currentProblem.id);
            if(index >= 0){
                this.current = index
                return
            }
            this.current = this.current - 1
        },
        next(){
            if (!this.currentProblem.id) {
                return
            }
            // 最后一题
            if(this.currentProblem.isOrFirst === 1){
               return
            }
            // 存在下一题 则直接跳转下一题
            if(this.currentProblem.next){
                let index = this.problems.findIndex( p => p.id === this.currentProblem.next);
                this.current = index > 0 ? index : this.current + 1
                return
            }
            this.current = this.current + 1
        },
        async submit(){
            let param = {
                salesId: this.$wxuserUtil.getUserId(),
                  custId: this.custId,
                  purchaseRecordId: this.purchaseRecordId,
                  json: JSON.stringify(this.problems),
            }
            try {
                this.loading = true
                let response = await this.$api.submitSurvey(param);   
                this.loading = false                 
                if(response.fail){
                    this.$title("提交问卷失败" + response.msg ? ', ' + response.msg : '')
                    return
                }                
                this.$title("提交问卷成功");
                this.redirectClientDetail();
            } catch (error) {
                console.log(error);
                this.loading = false;
                this.$title("提交问卷失败")
            }                        
        },
        redirectClientDetail(){
            this.$router.push({
                path: "/ClientDetails",
                query: {
                    custId: this.custId,
                    IdCode: 12,
                    showCC: this.$store.state.show==1||localStorage.getItem('show')==1
                },
            })}
    }
}
</script>    
<style scoped lang="less" rel="stylesheet/less">
.logo {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  img {
    width: 2rem;
    height: 2rem;
    margin: 30px auto;
  }
}

.content {
  margin: 0.5rem;
}
.loading {
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer {
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.secondary {
  background-color: #222;
}
.primary {
  background-color: #e10913;
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/submitSurvey.vue